import {
  invitationToEventTypeMembership,
  migrationToEventTypeMembership,
  organizationMembershipToEventTypeMembership
} from 'components/event_type_edit'

export const serializeOlp = (eventType, participants, updateLocation) => {
  const existingAccessGrantsAttributes = eventType.access_grants.map((accessGrant) => {
    const participant = participants.find(
      ({ principleType, principleUuid }) => principleType === accessGrant.principle_type
        && principleUuid === accessGrant.principle_uuid
    )

    if (participant) {
      return {
        id: accessGrant.id,
        role: participant.role,
      }
    }

    return {
      id: accessGrant.id,
      _destroy: true,
    }
  })
  const accessGrants = participants.map((participant) => ({
    principle_type: participant.principleType,
    principle_uuid: participant.principleUuid,
    role: participant.role,
  }))

  const attributes = {
    update_location: updateLocation,
    access_grants: accessGrants,
    event_type_access_grants_attributes: existingAccessGrantsAttributes
  }


  return attributes
}

export const eventTypeMembershipToParticipant = (membership) => {
  switch (membership.type) {
    case 'OrganizationMembership':
      return {
        principleType: 'User',
        principleUuid: membership.user_uuid,
        isHost: membership.enabled ?? true,
        role: 'editor',
        userId: membership.user_id,
        organizationMembershipId: membership.organization_membership_id,
        organizationInvitationId: null,
        eventTypeMembership: membership,
      }
    case 'OrganizationInvitation':
      return {
        principleType: 'OrganizationInvitation',
        principleUuid: membership.organization_invitation_uuid,
        isHost: membership.enabled ?? true,
        role: 'editor',
        userId: null,
        organizationMembershipId: null,
        organizationInvitationId: membership.organization_invitation_id,
        eventTypeMembership: membership,
      }
    default:
      throw new Error(`Unknown membership type: ${membership.type}`)
  }
}

export const eventTypeAccessGrantToParticipant = (accessGrant) => ({
  principleType: accessGrant.principle_type,
  principleUuid: accessGrant.principle_uuid,
  isHost: false,
  role: accessGrant.role,
  userId: accessGrant.user_id,
  organizationMembershipId: accessGrant.organization_membership_id,
  organizationInvitationId: accessGrant.organization_invitation_id,
  eventTypeMembership: null,
})

export const organizationMembershipToParticipant = (membership) => {
  if (membership.user_id) {
    return {
      principleType: 'User',
      principleUuid: membership.user_uuid,
      isHost: true,
      role: 'editor',
      userId: membership.user_id,
      organizationMembershipId: membership.id,
      organizationInvitationId: null,
      eventTypeMembership: organizationMembershipToEventTypeMembership(membership),
    }
  }

  if (membership.target_organization_uuid) {
    return {
      principleType: 'OrganizationInvitation',
      principleUuid: membership.uuid,
      isHost: true,
      role: 'editor',
      userId: null,
      organizationMembershipId: null,
      organizationInvitationId: membership.invitation_id,
      eventTypeMembership: migrationToEventTypeMembership(membership),
    }
  }

  return {
    principleType: 'OrganizationInvitation',
    principleUuid: membership.uuid,
    isHost: true,
    role: 'editor',
    userId: null,
    organizationMembershipId: null,
    organizationInvitationId: membership.id,
    eventTypeMembership: invitationToEventTypeMembership(membership),
  }
}
